import React from 'react';
import PropTypes from 'prop-types';

import Booking from 'models/booking';

import RefundNotice from 'components/bookings/past/info/refund-notice';

const propTypes = {
  booking: PropTypes.instanceOf(Booking).isRequired,
  disabled: PropTypes.bool,
};

const defaultProps = {
  disabled: false,
};

const PastBookingInfoStatus = ({ disabled, booking }) => {
  if (disabled) {
    return (
      <div>
        <div className="grid-header text-weight-book refunded">REFUNDED</div>
        <RefundNotice cancelledAt={booking.cancelledAt} />
      </div>
    );
  }

  if (booking.onDemand) {
    return (
      <div>
        <div className="grid-header text-weight-book">Receipt</div>
        <div className="grid-header text-weight-book">#{booking.id}</div>
      </div>
    );
  }

  let businessIcon;
  if (booking.businessPurchase) {
    businessIcon = (
      <div className="grid-header text-weight-book">
        <span className="iconified-font iconified-briefcase" />
      </div>
    );
  }

  return (
    <div>
      {businessIcon}
      <div className="grid-header weak">Purchased</div>
      <div className="grid-header weak">{booking.purchasedAt.format('ddd MMM DD, YYYY')}</div>
    </div>
  );
};

PastBookingInfoStatus.propTypes = propTypes;
PastBookingInfoStatus.defaultProps = defaultProps;
export default PastBookingInfoStatus;
